import { NoResults } from "components";
import { type FC } from "react";

export interface SendsNoResultsProps {
  createButton?: React.ReactElement;
}

const SendsNoResults: FC<SendsNoResultsProps> = ({ createButton }) => {
  return (
    <NoResults
      title="You don't have any scheduled sends"
      description="You don't have any scheduled sends yet. Create one now using the button below."
      fontAwesomeIcon="faPaperPlane"
    >
      {createButton}
    </NoResults>
  );
};

export default SendsNoResults;
